import { render, staticRenderFns } from "./label.vue?vue&type=template&id=3c6041bd&"
var script = {}
import style0 from "./label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6041bd')) {
      api.createRecord('3c6041bd', component.options)
    } else {
      api.reload('3c6041bd', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=3c6041bd&", function () {
      api.rerender('3c6041bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-table/label.vue"
export default component.exports